import React, { useEffect } from "react";
import { Menu } from "antd";
import type { MenuProps } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import usePermission from "../hooks/usePermission";
import { MENUS } from '../const/menu';
import { useOnboarding } from "../zustand/useOnboarding";

const Sidebar: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isUserHasPermission } = usePermission();
  const { isOnboardingPage, setIsOnboardingPage } = useOnboarding()


  const filterMenuOnlyHasPermission = (items: any[]) => {
    return items
      .map((item) => {
        if (item.permission && Array.isArray(item.permission)) {
          item.permission = isUserHasPermission(item.permission);
        }

        if (item.children) {
          item.children = filterMenuOnlyHasPermission(item.children);

          if (item.children.length === 0) {
            item.permission = false;
          } else {
            item.permission = true;
          }
        }

        if (item.permission) {
          return item;
        } else {
          return null;
        }
      })
      .filter((item) => item);
  };

  const items = filterMenuOnlyHasPermission(MENUS) as MenuProps["items"];

  const convertPathName = () => {
    const pathname = location.pathname.split("/");
    const res = "/" + pathname[1];
    return res;
  };

  const getSelectedParent = () => {
    const currentMenu = convertPathName();
    var parent: string[] = [];
    if (items) {
      for (const group of items) {
        if (group && "children" in group && group.children) {
          for (const submenu of group.children) {
            var current = String(submenu?.key ? submenu.key : "");
            if (submenu && "children" in submenu && submenu.children) {
              for (const item of submenu.children) {
                if (
                  item &&
                  "path" in item &&
                  (item as any).path === currentMenu &&
                  current !== undefined
                ) {
                  parent.push(current);
                }
              }
            }
          }
        }
      }
    }
    return parent;
  };

  const [selectedKey, setSelectedKey] = React.useState(location.pathname);

  // Sinkronkan dengan lokasi saat berubah secara manual / dari luar
  useEffect(() => {
    setSelectedKey(location.pathname);
  }, [location.pathname]);

  const handleMenuClick = ({ key }: any) => {
    const currentPath = location.pathname;
    if (currentPath.includes('/merchant/add') && key !== currentPath && isOnboardingPage) {
      const confirmLeave = window.confirm('Leave site?\nChanges you made may not be saved.');
      if (!confirmLeave) {
        return;
      } else {
        setIsOnboardingPage(false);
        setSelectedKey(key);
        navigate(key);
      }
    } else {
      setIsOnboardingPage(false);
      setSelectedKey(key);
      navigate(key);
    }
  };
  


  return (
    <Menu
      mode="inline"
      className="custom-scrollbar"
      style={{ paddingBottom: 200, height: '100vh', overflow: 'scroll', width: '200px' }}
      defaultSelectedKeys={[convertPathName()]}
      defaultOpenKeys={getSelectedParent()}
      selectedKeys={[selectedKey]}

      items={items}
      onClick={handleMenuClick}
    />
  );
};
export default Sidebar;
